import { Ago } from "shared/react";
import { type MessageData, getMarkupFirstLine } from "shared/schema";
import { EntityName } from "../entity/EntityName.js";
import { useItem } from "../util/db.js";

/** One-sentence summary of a message, e.g. `@dhoulb: Wow that sounds... (2d)` */
export function RawMessageSentence({ date, creator, content }: MessageData): React.ReactElement {
	return (
		<span>
			<Ago target={date} />: <EntityName entity={creator} /> <span className="weight-normal">{getMarkupFirstLine(content)}</span>
		</span>
	);
}

export function MessageSentence({ id }: { id: string }): React.ReactElement {
	const update = useItem("message", id).data;
	return <RawMessageSentence {...update} />;
}
